import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, SelectField, MenuItem, Dialog, FlatButton } from "material-ui"
import autobind from "class-autobind"
import Table from "../../../../components/common/Table"
import TableActionBar from "../../../../components/layout/TableActionBar"
import { IFAMAccountDTO } from "../../../../models/data/account_manager/FAMAccountDTO"
import AppStateStore from "../../../../stores/AppStateStore"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import _ from "lodash"

interface IProps {
    open: boolean
    title: string
    accountManagerId?: string
    onClose(): void
    onSelect(selectedClientAccount: IFAMAccountDTO): void
}

interface IState {
    clientAccounts: IFAMAccountDTO[]
    selectedClientAccounts: IFAMAccountDTO[]
    activeClient: boolean
    searchText: string
}

export default class AccountManagerSystemTabAccountSelectionDialog extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            clientAccounts: [],
            selectedClientAccounts: [],
            activeClient: true,
            searchText: "",
        }
        autobind(this)
    }

    componentDidMount(): void {
        this.getAccounts()
    }

    getAccounts() {
        AppStateStore.setProgressSnackbarContent("loading")
        api.getAccountManagerAccounts({ AccountManagerId: this.props.accountManagerId, Active: this.state.activeClient, Text: this.state.searchText, Page: 0, Limit: 10000 })
        .then(res => {
            const clientAccounts = res.data.Accounts as IFAMAccountDTO[]
            this.setState({ clientAccounts }, () => AppStateStore.setProgressSnackbarContent(null))
        })
        .catch(err => {
            AppStateStore.setProgressSnackbarContent(null)
            err.response.status === 400 &&
                AppStateStore.setProgressSnackbarContent(err.response.data.message)
        })
    }

    onSearchChange = _.debounce(searchText => this.setState({ searchText }, () => this.getAccounts()), 1000)

    render() {
        return (
            <Dialog
                open={this.props.open}
                title={<h2 style={{ color: "#616161" }}>{this.props.title}</h2>}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10, fontWeight: "bold" }}
                autoScrollBodyContent
                actions={[
                    <FlatButton
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.onClose}
                    />,
                    <FlatButton
                        label={strings.Select}
                        primary
                        onClick={() => this.props.onSelect(this.state.selectedClientAccounts[0])}
                        disabled={this.state.selectedClientAccounts.length === 0}
                    />
                ]}
            >
                <div style={{ padding: 30 }}>
                    <SelectField
                        floatingLabelText={strings.Active_Status}
                        value={this.state.activeClient}
                        onChange={(_e, _key, activeClient) => this.setState({ activeClient }, () => this.getAccounts())}
                        style={{ marginLeft: 35, marginTop: -15, width: 250 }}
                    >
                        <MenuItem key={"active"} value={true} primaryText={strings.Active} />
                        <MenuItem key={"inactive"} value={false} primaryText={strings.Inactive} />
                    </SelectField>
                    <TableActionBar
                        rowSelectionCount={this.state.selectedClientAccounts.length}
                        singleSelectedMessage={strings.Client_Selected}
                        multipleSelectedMessage={strings.x_Client_Selected}
                        onSearch={searchText => this.onSearchChange(searchText)}
                        searchText={this.state.searchText}
                        readonly={true}
                    />
                    <Table 
                        items={this.state.clientAccounts} 
                        allowClickRow 
                        singleSelectable
                        handleSelect={(selectedClientAccounts) => this.setState({ selectedClientAccounts })}
                        uniqueIdentifier={"AccountId"}
                        readonly={false}
                    >
                        <TableHeader>
                            <TableRow>
                                <TableHeaderColumn>{strings.Name}</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody showRowHover deselectOnClickaway={false}>
                            {this.state.clientAccounts.map((row) =>
                                <TableRow key={row.AccountId} selected={this.state.selectedClientAccounts.find(item => item.AccountId === row.AccountId) ? true : false}>
                                    <TableRowColumn >
                                        {row.Name}
                                    </TableRowColumn>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
            </Dialog>
        )
    }
}